import {usePlayerViewPort} from "@/encounter/viewport/PlayerViewPortHooks.ts";
import {srcUrl} from "@/api/ImageApi.ts";
import questionSvg from "@assets/question.svg";
import {Image} from "@/images/Image.ts";
import {useCachedImage} from "@/images/ImageCache.ts";

export function useScreenCenter() {
    const playerViewPort = usePlayerViewPort()
    return {
        x: playerViewPort.centerX,
        y: playerViewPort.centerY,
    };
}

export function usePortrait(size: number, image?: Image) {
    const actualImage = image ? srcUrl(image) : questionSvg;
    const portrait = useCachedImage(actualImage)

    if (!portrait) return null;
    const scale = size / Math.max(portrait.height, portrait.width);
    return {
        image: portrait,
        width: portrait.width * scale,
        height: portrait.height * scale,
        scale: scale,
    };
}


export const TokenColors = {
    hostile: {dark: '#68010a', normal: '#9f0712', light: '#c70036'},
    friendly: {dark: '#006045', normal: '#00976c', light: '#00bc7d'},
    selected: {dark: '#9e5000', normal: '#e17100', light: '#fb9125'}

}
